import { render, staticRenderFns } from "./stu_LayoutHeader2.vue?vue&type=template&id=d2a01580&scoped=true"
import script from "./stu_LayoutHeader2.vue?vue&type=script&lang=js"
export * from "./stu_LayoutHeader2.vue?vue&type=script&lang=js"
import style0 from "./stu_LayoutHeader2.vue?vue&type=style&index=0&id=d2a01580&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a01580",
  null
  
)

export default component.exports